if (!customElements.get('ob-shade-picker')) {
  customElements.define('ob-shade-picker', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.trigger = this.querySelector('[data-shade-trigger]');
      this.dialog = this.querySelector('dialog');
      this.fallback = this.querySelector('[data-shade-fallback]');
      if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.trigger.hidden = false;
      if (this.fallback) this.fallback.hidden = true;
      this.mobile = window.matchMedia('(max-width: 767.98px)');
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return this.close(true);
        this.restoreFocus = true;
        if (this.mobile.matches) {
          this.previousOverflow = document.documentElement.style.overflow;
          this.scrollLocked = true;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
        } else {
          if (window.innerHeight - this.trigger.getBoundingClientRect().bottom < 220) {
            this.trigger.scrollIntoView({ block: 'center', behavior: 'instant' });
          }
          const availableSpace = window.innerHeight - this.trigger.getBoundingClientRect().bottom - 20;
          this.dialog.style.setProperty('--ob-shade-space', Math.max(180, availableSpace) + 'px');
          this.dialog.show();
        }
        this.trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelector('[data-shade-close]').addEventListener('click', () => this.close(true), options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close(true);
      }, options);
      this.dialog.addEventListener('close', () => this.finishClose(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) return this.close(false);
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right ||
            event.clientY < box.top || event.clientY > box.bottom) this.close(true);
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (this.dialog.open && !this.mobile.matches && !this.contains(event.target)) this.close(false);
      }, options);
      document.addEventListener('keydown', (event) => {
        if (this.dialog.open && event.key === 'Escape') {
          event.preventDefault();
          this.close(true);
        }
      }, options);
      this.mobile.addEventListener('change', () => this.close(false), options);
    }
    close(restoreFocus) {
      if (!this.dialog?.open) return;
      this.restoreFocus = restoreFocus;
      this.dialog.close();
    }
    finishClose() {
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.scrollLocked) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
      if (this.restoreFocus && this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.restoreFocus = false;
      this.finishClose();
      this.abort?.abort();
    }
  });
}
